import { NgModule } from '@angular/core';
import { SortablejsDirective } from './sortablejs.directive';
var SortablejsModule = (function () {
    function SortablejsModule() {
    }
    SortablejsModule.forRoot = function (globalOptions) {
        SortablejsModule._globalOptions = globalOptions;
        return SortablejsModule;
    };
    return SortablejsModule;
}());
export { SortablejsModule };
SortablejsModule._globalOptions = {};
SortablejsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SortablejsDirective],
                exports: [SortablejsDirective]
            },] },
];
/** @nocollapse */
SortablejsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=sortablejs.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-sortablejs/dist/src/sortablejs.module.js
// module id = 619
// module chunks = 10